module.exports = __webpack_public_path__ + "static/che7-4df122fcbcdd049fcb06492d21c7cae9.jpg";